/**
 * Variant Stock Indicator for Chair Dinkum
 * Adds "Pre-order" or "Available" text below base colour buttons.
 * Hides base buttons that don't exist for the selected colour.
 * Works with Impulse theme's variant button selector.
 *
 * When data-hide-oos="true" is set on the product section:
 * - Out-of-stock colour swatches are hidden entirely
 * - Out-of-stock base options are hidden entirely
 * - On page load, auto-selects the first in-stock colour if the default is OOS
 * This is used on HÅG Capisco pages only.
 *
 * CAP-PO1 (28 Oct 2026): when the product has open incoming-shipment pre-orders (cd-pdp2 cfg.inc),
 * hide-OOS pages show two colour rows instead: In stock, and Pre-order arriving <eta>.
 */
(function() {
  'use strict';
  var PREORDER_TEXT = 'Pre-order';
  var AVAILABLE_TEXT = 'Available';
  var BADGE_CLASS = 'cd-preorder-badge';

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '.' + BADGE_CLASS + ' { display: block; text-align: center; font-size: 0.75rem; margin-top: 4px; font-weight: 500; }',
    '.' + BADGE_CLASS + '--available { color: #2e7d32; }',
    '.' + BADGE_CLASS + '--preorder { color: #c1553b; }'
  ].join(' ');
  document.head.appendChild(style);


  // ---------------------------------------------------------------------------
  // CAP-PO1 (28 Oct 2026): grouped colour rows on hide-OOS (Capisco) pages when an
  // incoming shipment is open. Row 1 "In stock" = colours with an in-stock base.
  // Row 2 "Pre-order · arriving <eta>" = colours with a base on the incoming shipment
  // that still has pre-order capacity (data from cd-pdp2 data-cd-ps: cfg.inc / cfg.eta).
  // A colour in both rows has its real swatch in row 1 and a proxy swatch in row 2.
  // The row a colour was picked from decides which bases are offered.
  // ---------------------------------------------------------------------------
  function readPsCfg(section) {
    var el = section.querySelector('script[data-cd-ps]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function groupedMode(section, variants, cfg, explicitVariant) {
    var inc = cfg.inc || {};
    if (!Object.keys(inc).length || variants[0].option2 == null) return false;
    var colourFs = section.querySelector('fieldset[data-index="option1"]');
    var baseFs = section.querySelector('fieldset[data-index="option2"]');
    if (!colourFs || !baseFs) return false;

    function stOf(v) {
      if ((v.inventory_quantity || 0) > 0) return 'stock';
      if (inc[String(v.id)] > 0) return 'po';
      return 'none';
    }
    var map = {};
    variants.forEach(function(v) {
      var c = v.option1, b = v.option2, st = stOf(v);
      map[c] = map[c] || {};
      var e = map[c][b];
      if (!e || e === 'none' || (e === 'po' && st === 'stock')) map[c][b] = st;
    });
    function has(c, st) {
      var m = map[c] || {};
      return Object.keys(m).some(function(b) { return m[b] === st; });
    }

    if (!document.getElementById('cd-po-style')) {
      var css = document.createElement('style');
      css.id = 'cd-po-style';
      css.textContent = [
        '.cd-po-grp{margin:0 0 6px}',
        '.cd-po-grp + .cd-po-grp{margin-top:10px}',
        '.cd-po-grp__h{display:flex;align-items:center;gap:8px;font-size:.75rem;letter-spacing:.1em;text-transform:uppercase;font-weight:600;color:#3d3935;margin:0 0 10px}',
        '.cd-po-grp__h:before{content:"";width:8px;height:8px;border-radius:50%;background:#2e7d32;flex-shrink:0}',
        '.cd-po-grp--po .cd-po-grp__h:before{background:#c1553b}',
        '.cd-po-grp__note{display:block;font-size:.75rem;letter-spacing:0;text-transform:none;font-weight:400;color:#6b6862;margin:-6px 0 10px}',
        '.cd-mode-po .cd-po-grp--stock input[type=radio]:checked+label{box-shadow:0 0 0 1px var(--colorBorder)}',
        '.cd-po-proxy label{cursor:pointer}',
        '.cd-po-proxy.is-sel label{box-shadow:0 0 0 2px var(--colorTextBody)}',
        '.cd-po-active .cd-preorder-badge{display:none}',
        '@media only screen and (max-width:768px){.cd-po-grp__h{justify-content:center}.cd-po-grp__note{text-align:center}}'
      ].join('');
      document.head.appendChild(css);
    }
    section.classList.add('cd-po-active');

    function mkGroup(kind, heading, note) {
      var el = document.createElement('div');
      el.className = 'cd-po-grp cd-po-grp--' + kind;
      var h = document.createElement('p');
      h.className = 'cd-po-grp__h';
      h.textContent = heading;
      el.appendChild(h);
      if (note) {
        var n = document.createElement('span');
        n.className = 'cd-po-grp__note';
        n.textContent = note;
        el.appendChild(n);
      }
      var row = document.createElement('div');
      row.className = 'cd-po-grp__row';
      el.appendChild(row);
      return { el: el, row: row };
    }

    var eta = cfg.eta || 'soon';
    var gS = mkGroup('stock', 'In stock · ready to ship', '');
    var gP = mkGroup('po', 'Pre-order · arriving ' + eta, 'Order now to reserve one from our incoming shipment.');
    var divs = Array.prototype.slice.call(colourFs.querySelectorAll('.variant-input'));
    colourFs.appendChild(gS.el);
    colourFs.appendChild(gP.el);

    var mode = 'stock', forcePo = false, proxies = {};

    function mkProxy(div, c) {
      var p = document.createElement('div');
      p.className = 'variant-input cd-po-proxy';
      p.setAttribute('data-value', c);
      var src = div.querySelector('label');
      var lab = src.cloneNode(true);
      lab.removeAttribute('for');
      lab.setAttribute('role', 'button');
      lab.setAttribute('tabindex', '0');
      lab.setAttribute('aria-label', c + ' (pre-order, arriving ' + eta + ')');
      p.appendChild(lab);
      function go(e) {
        e.preventDefault();
        var inp = div.querySelector('input[type="radio"]');
        if (inp && inp.checked) { mode = 'po'; refresh(); return; }
        forcePo = true;
        src.click();
      }
      lab.addEventListener('click', go);
      lab.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
      return p;
    }

    divs.forEach(function(div) {
      var inp = div.querySelector('input[type="radio"]');
      if (!inp) return;
      var c = inp.value, hs = has(c, 'stock'), hp = has(c, 'po');
      var isExp = explicitVariant && explicitVariant.option1 === c;
      if (hs) {
        gS.row.appendChild(div);
        if (hp) { proxies[c] = mkProxy(div, c); gP.row.appendChild(proxies[c]); }
      } else if (hp) {
        gP.row.appendChild(div);
      } else {
        gS.row.appendChild(div);
        div.style.display = isExp ? '' : 'none';
      }
    });
    function visibleIn(row) {
      return Array.prototype.some.call(row.children, function(d) { return d.style.display !== 'none'; });
    }
    if (!visibleIn(gS.row)) gS.el.style.display = 'none';
    if (!visibleIn(gP.row)) gP.el.style.display = 'none';

    function selectedColour() {
      var ch = colourFs.querySelector('input[type="radio"]:checked');
      return ch ? ch.value : null;
    }

    function refresh() {
      var c = selectedColour();
      if (!c) return;
      colourFs.classList.toggle('cd-mode-po', mode === 'po');
      Object.keys(proxies).forEach(function(k) {
        proxies[k].classList.toggle('is-sel', mode === 'po' && k === c);
      });
      var bases = map[c] || {};
      var want = mode === 'po' ? 'po' : 'stock';
      var anyWanted = Object.keys(bases).some(function(b) { return bases[b] === want; });
      baseFs.querySelectorAll('.variant-input').forEach(function(div) {
        var inp = div.querySelector('input[type="radio"]');
        if (!inp) return;
        var badge = div.querySelector('.' + BADGE_CLASS);
        if (badge) badge.remove();
        var b = inp.value;
        var isExp = explicitVariant && explicitVariant.option1 === c && explicitVariant.option2 === b;
        var show = (b in bases) && (anyWanted ? bases[b] === want : true);
        div.style.display = (show || isExp) ? '' : 'none';
      });
      var checked = baseFs.querySelector('input[type="radio"]:checked');
      var parent = checked ? checked.closest('.variant-input') : null;
      if (!parent || parent.style.display === 'none') {
        var first = baseFs.querySelector('.variant-input:not([style*="display: none"]) label');
        if (first) first.click();
      }
    }

    colourFs.addEventListener('change', function() {
      var c = selectedColour();
      mode = forcePo ? 'po' : (has(c, 'stock') ? 'stock' : 'po');
      forcePo = false;
      setTimeout(refresh, 60);
    });

    // Initial state
    if (explicitVariant) {
      mode = stOf(explicitVariant) === 'po' ? 'po' : 'stock';
    } else {
      var c0 = selectedColour();
      if (c0 && has(c0, 'stock')) {
        mode = 'stock';
      } else {
        var target = gS.row.querySelector('.variant-input:not([style*="display: none"]) label') ||
                     gP.row.querySelector('.variant-input:not(.cd-po-proxy) label');
        if (target) target.click();
      }
    }
    setTimeout(refresh, 150);
    return true;
  }

  function init() {
    // Find the product section
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    // Check if this page is in "hide out-of-stock" mode (Capisco pages)
    var hideOos = section.getAttribute('data-hide-oos') === 'true';

    // Get variant data from the textarea
    var textarea = section.querySelector('textarea[data-variant-json]');
    if (!textarea) return;
    var variants;
    try {
      variants = JSON.parse(textarea.value);
    } catch(e) { return; }
    if (!variants || !variants.length) return;

    // PDP2: an explicit, valid ?variant= is a deliberate deep link (e.g. a pre-order colour). Keep it visible and selected.
    var explicitVariant = null;
    try {
      var explicitId = new URLSearchParams(window.location.search).get('variant');
      if (explicitId) {
        explicitVariant = variants.find(function(vv) { return String(vv.id) === String(explicitId); }) || null;
      }
    } catch(e) {}

    // CAP-PO1: grouped in-stock / pre-order rows when an incoming shipment is open
    if (hideOos) {
      var psCfg = readPsCfg(section);
      if (psCfg && groupedMode(section, variants, psCfg, explicitVariant)) return;
    }

    // Determine if this product has 2 options (colour + base) or 1 option
    var hasTwoOptions = variants[0].option2 != null;

    if (!hasTwoOptions) {
      // Single-option product: hide out-of-stock options if hideOos is true
      if (!hideOos) return;
      var fieldset = section.querySelector('fieldset[data-index="option1"]');
      if (!fieldset) return;
      var inputDivs = fieldset.querySelectorAll('.variant-input');
      inputDivs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var v = variants.find(function(vv) { return vv.option1 === input.value; });
        if (explicitVariant && explicitVariant.option1 === input.value) return;
        if (v && (v.inventory_quantity || 0) <= 0) {
          inputDiv.style.display = 'none';
        }
      });
      return;
    }

    // Build lookup: { option1Value: { option2Value: inventory_quantity } }
    var stockMap = {};
    variants.forEach(function(v) {
      var colour = v.option1;
      var base = v.option2;
      if (!stockMap[colour]) stockMap[colour] = {};
      var existing = stockMap[colour][base];
      var qty = v.inventory_quantity || 0;
      if (existing === undefined || qty > existing) {
        stockMap[colour][base] = qty;
      }
    });

    // Find the colour fieldset (option1) and base fieldset (option2)
    var colourFieldset = section.querySelector('fieldset[data-index="option1"]');
    var baseFieldset = section.querySelector('fieldset[data-index="option2"]');
    if (!colourFieldset || !baseFieldset) return;

    // Helper: get currently selected colour value
    function getSelectedColour() {
      var checked = colourFieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    // Helper: does a colour have any in-stock base?
    function colourHasStock(colourValue) {
      var bases = stockMap[colourValue] || {};
      return Object.keys(bases).some(function(base) {
        return bases[base] > 0;
      });
    }

    // Hide out-of-stock colour swatches (option1) when hideOos is true
    function updateColourVisibility() {
      if (!hideOos) return;
      var colourInputs = colourFieldset.querySelectorAll('.variant-input');
      colourInputs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var colourValue = input.value;
        if (!colourHasStock(colourValue) && !(explicitVariant && explicitVariant.option1 === colourValue)) {
          inputDiv.style.display = 'none';
        } else {
          inputDiv.style.display = '';
        }
      });
    }

    // Auto-select the first in-stock colour if the current default has no stock
    function autoSelectFirstInStockColour() {
      if (!hideOos) return;
      if (explicitVariant) return; // PDP2: respect the deep-linked variant
      var selectedColour = getSelectedColour();
      if (selectedColour && colourHasStock(selectedColour)) return; // current colour is fine

      // Find the first visible colour input that has stock
      var colourInputs = colourFieldset.querySelectorAll('.variant-input');
      for (var i = 0; i < colourInputs.length; i++) {
        var inputDiv = colourInputs[i];
        // Skip already-hidden ones
        if (inputDiv.style.display === 'none') continue;
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) continue;
        if (colourHasStock(input.value)) {
          // Click the label to trigger Shopify's native variant change logic
          var label = inputDiv.querySelector('label');
          if (label) {
            label.click();
          } else {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }

    // Update base buttons: hide non-existent combos, and hide/badge out-of-stock ones
    function updateBaseIndicators() {
      var selectedColour = getSelectedColour();
      if (!selectedColour) return;
      var colourBases = stockMap[selectedColour] || {};
      var baseInputs = baseFieldset.querySelectorAll('.variant-input');

      baseInputs.forEach(function(inputDiv) {
        var input = inputDiv.querySelector('input[type="radio"]');
        if (!input) return;
        var baseValue = input.value;

        // Remove existing badge if any
        var existingBadge = inputDiv.querySelector('.' + BADGE_CLASS);
        if (existingBadge) existingBadge.remove();

        // Check if this base exists for the selected colour
        var exists = baseValue in colourBases;
        if (!exists) {
          // Hide the button entirely — this colour+base combo doesn't exist
          inputDiv.style.display = 'none';
          return;
        }

        // Show the button
        inputDiv.style.display = '';
        var qty = colourBases[baseValue];

        var isExplicit = explicitVariant && explicitVariant.option1 === selectedColour && explicitVariant.option2 === baseValue;
        if (hideOos && qty <= 0 && !isExplicit) {
          // In hide-OOS mode: hide out-of-stock base options entirely
          inputDiv.style.display = 'none';
        } else if (!hideOos) {
          // In normal mode: show Pre-order / Available badge
          var badge = document.createElement('span');
          badge.className = BADGE_CLASS;
          if (qty <= 0) {
            badge.textContent = PREORDER_TEXT;
            badge.classList.add(BADGE_CLASS + '--preorder');
          } else {
            badge.textContent = AVAILABLE_TEXT;
            badge.classList.add(BADGE_CLASS + '--available');
          }
          inputDiv.appendChild(badge);
        }
        // In hide-OOS mode with qty > 0: just show the button, no badge needed
      });

      // After updating base options, if the currently selected base is now hidden,
      // auto-select the first visible base
      if (hideOos) {
        var checkedBase = baseFieldset.querySelector('input[type="radio"]:checked');
        var checkedParent = checkedBase ? checkedBase.closest('.variant-input') : null;
        if (!checkedParent || checkedParent.style.display === 'none') {
          // Find first visible base and click it
          var firstVisible = baseFieldset.querySelector('.variant-input:not([style*="display: none"]) label');
          if (firstVisible) {
            firstVisible.click();
          } else {
            var firstVisibleInput = baseFieldset.querySelector('.variant-input:not([style*="display: none"]) input[type="radio"]');
            if (firstVisibleInput) {
              firstVisibleInput.checked = true;
              firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }

    // Listen for colour changes
    colourFieldset.addEventListener('change', function() {
      setTimeout(updateBaseIndicators, 50);
    });

    // Also listen for clicks on colour swatches (for image-based swatches)
    colourFieldset.addEventListener('click', function(e) {
      if (e.target.classList.contains('color-swatch') ||
          e.target.classList.contains('variant__button-label') ||
          e.target.closest('.variant-input')) {
        setTimeout(updateBaseIndicators, 100);
      }
    });

    // Run on initial load:
    // 1. Hide OOS colours first
    // 2. Auto-select first in-stock colour if default is OOS
    // 3. Update base indicators for the (now correct) selected colour
    updateColourVisibility();
    autoSelectFirstInStockColour();
    // Small delay to let Shopify's own variant JS process the colour click above
    setTimeout(function() {
      updateBaseIndicators();
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
